export default "__VITE_ASSET__B8YEz8bq__"